import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const ANCHOR_HIDDEN_CLASS =
  "data-[anchor-hidden]:invisible data-[anchor-hidden]:pointer-events-none";
